// extracted by mini-css-extract-plugin
module.exports = {"root":"_9YQNR-Y","rootMarlrg":"_1I1vNGC","rootWhite":"_3tR1yh3","number":"_3GlOY3W"};